// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconPlaybackPause = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M28 12.685V51.3235C28 52.9214 26.9666 53.9094 25.3711 53.821C20.0366 53.5253 16.2856 52.9165 13.9124 52.4375C12.5835 52.1693 11.8308 51.4166 11.5626 50.0878C10.9741 47.1717 10 40.9881 10 32.0002C10 23.0123 10.905 17.1705 11.5626 13.9125C11.8308 12.5837 12.5835 11.831 13.9124 11.5628C16.0432 11.1327 19.9248 10.4985 25.3657 10.1877C26.9631 10.0964 28 11.085 28 12.685ZM52.4369 13.9101C52.1975 12.7242 51.2742 11.8023 50.0881 11.5629C47.7151 11.0839 43.964 10.475 38.6292 10.1793C37.0337 10.0909 36 11.0788 36 12.6767V51.3153C36 52.9153 37.0369 53.9039 38.6343 53.8127C44.0752 53.5018 47.9568 52.8676 50.0876 52.4375C51.4165 52.1693 52.1692 51.4166 52.4374 50.0878C53.0259 47.1717 54 40.9881 54 32.0002C54 23.0101 53.0945 17.1677 52.4369 13.9101Z" />
    </svg>
  );
};
